export default __webpack_public_path__ + "static/media/portfolio-71.4f4d7d55.jpg";